

import { useState } from "react";
import { BaseModal, ModalCloseCross, type BaseModalProps } from "../../../../components/modals/BaseModal";
import { ComunicacionAjax } from "../../../../ts/api/comunicacion";
import type { Respuesta } from "../../../../ts/typings/clases";
import { notificacion, notificacionError } from "../../../../components/Alerts";
import { useQueryClient } from "@tanstack/react-query";

interface ModalConfirmarLanzarProps extends BaseModalProps {
	readonly pedidosMarcados: Record<string, boolean>;
}
export function ModalConfirmarLanzar(props: ModalConfirmarLanzarProps) {
	const pedidos = Object.entries(props.pedidosMarcados).filter(([_id, marcado]) => marcado).map(([id]) => parseInt(id));
	const queryClient = useQueryClient();
	const [prioridad, setPrioridad] = useState("3");

	const onConfirmarCiclo = () => {
		void lanzarCiclo(prioridad, pedidos)
			.then(success => {
				void queryClient.invalidateQueries({ queryKey: ["getCiclos"] });
				if (success) props.close();
			});
	};

	return (
		<BaseModal show={props.show} close={props.close}>
			<div className="modal-header" style={{ display: "flex", justifyContent: "space-between" }}>
				<h2 className="modal-title">Pasar pedidos a fabrica</h2>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body" style={{ textAlign: "center" }}>
				<p>¿Desea enviar el enviar los siguientes pedidos a fábrica como nuevo ciclo?</p>
				<div id="pedidosParaCiclo">
					{pedidos.join(", ")}
				</div>
				<h3>Prioridad</h3>
				<select className="form-control limpiar" style={{ textAlign: "center", paddingLeft: 27 }} value={prioridad} onChange={e => setPrioridad(e.target.value)}>
					<option value={1}>Tiempo Real</option>
					<option value={2}>Alta</option>
					<option value={3} selected>Normal</option>
					<option value={4}>Menor</option>
					<option value={5}>Baja</option>
				</select>
			</div>
			<div className="modal-footer">
				<button type="button" className="btnSecondary" onClick={props.close}>Cerrar</button>
				<button type="button" className="btnPrimary" onClick={onConfirmarCiclo}>Enviar</button>
			</div>
		</BaseModal>
	);
}
async function lanzarCiclo(prioridad: string, idsPedidos: number[]): Promise<boolean> {
	const response = await ComunicacionAjax.sendAjaxRequest<Respuesta>("POST", "/api/v1/lanzarACiclo", {
		"prioridad": prioridad,
		"idsPedidos": idsPedidos,
	});

	if (response.tipo != "exito") {
		notificacionError(response.message ?? "Error al lanzar el ciclo.");
		return false;
	}

	notificacion(response.message ?? "Ciclo lanzado correctamente.");
	return true;
}